import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";

import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import axios from "axios";
import {
  Box,
  CircularProgress,
  Icon,
  TableCell,
  TablePagination,
  Typography,
} from "@mui/material";

import { tableCellClasses } from "@mui/material/TableCell";
import { Image } from "@mui/icons-material";
import { Loader } from "@aws-amplify/ui-react";
import TennisTable from "./TennisTable";

import TennisCourtEstimate from "./TennisCourtEstimate";
import PickleBallCourt from "./PickleballCourt";
import BasketBallCourtHighSchool from "./BasketBallCourtHighSchool";
import BasketBallCourtNBA from "./BasketBallCourtNBA";
import ColorDisplay from "./ColorDisplay";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1A3E1F",
    color: "white",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 18,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "white",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(
  clientName,
  typeOfCourt,
  numberOfCourt,
  colors,
  contactInfo,
  email,
  size,
  zipCode,
  isResurfaced,
  createdAt
) {
  return {
    clientName,
    typeOfCourt,
    numberOfCourt,
    colors,
    contactInfo,
    email,
    size,
    zipCode,
    isResurfaced,
    createdAt,
    history: [
      {
        date: "2020-01-05",
        customerId: "11091700",
        amount: 3,
      },
      {
        date: "2020-01-02",
        customerId: "Anonymous",
        amount: 1,
      },
    ],
  };
}

function Row(props) {
  const { row, index ,color} = props;
  console.log("row", row);
  const [open, setOpen] = React.useState(false);

  const renderEstimate = (numberOfCourt, typeOfCourt, size) => {
    switch (typeOfCourt) {
      case "pickleball":
        // Add your logic for 'pickleball' case here
        return <PickleBallCourt n={numberOfCourt} />;

      case "tennis":
        // Add your logic for 'tennis' case here
        return <TennisCourtEstimate numberOfCourt={numberOfCourt} />;

      case "basketball":
        if (size !== "high-school-option-2") {
          return <BasketBallCourtNBA n={numberOfCourt} />;
        } else {
          return <BasketBallCourtHighSchool n={numberOfCourt} />;
        }

      default:
        // Handle invalid or undefined court types
        return "Invalid court type";
    }
  };

  return (
    <React.Fragment>
      <TableRow
        sx={{
          "& > *": { borderBottom: "unset" },
          backgroundColor: index % 2 == 0 ? "#9fe871" : "transparent",
        }}
      >
        <StyledTableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </StyledTableCell>
        <StyledTableCell component="th" scope="row">
          <Typography variant="h6">{row.clientName}</Typography>
        </StyledTableCell>
        <StyledTableCell align="center">
          <Typography variant="h6">{row.typeOfCourt}</Typography>
        </StyledTableCell>
        <StyledTableCell align="center">
          <Typography variant="h6">{row.numberOfCourt}</Typography>
        </StyledTableCell>
        <StyledTableCell align="center">
          <Typography variant="h6">{row.size}</Typography>
       
        </StyledTableCell>
        <StyledTableCell align="center">
          <Typography variant="h6">{row.contactInfo}</Typography>
        </StyledTableCell>
        <StyledTableCell align="center">
          <Typography variant="h6">{row.email}</Typography>
        </StyledTableCell>

        <StyledTableCell align="center">
          <Typography variant="h6">{row.zipCode}</Typography>
        </StyledTableCell>
        <StyledTableCell align="center">
          <Typography variant="h6">
            {new Date(row.createdAt).toLocaleString("en-US", {
              timeZone: "America/New_York",
            })}
          </Typography>
        </StyledTableCell>
        <StyledTableCell align="center">
          <Typography variant="h6">{row.isResurfaced ==="null" ? "No" : row.isResurfaced || 'No'}</Typography>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell sx={{ p: 0 }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {renderEstimate(row.numberOfCourt, row.typeOfCourt, row.size)}
            <ColorDisplay colors={row.colors} />
          </Collapse>
        </StyledTableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};

export default function Admin({ loader }) {
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!loader.current) {
      loader.current = true;
      setLoading(true);
      // Call the API
      axios
        .get(
          "https://ls3lz9m1jk.execute-api.us-east-1.amazonaws.com/master/courts-with-details"
        )
        .then((response) => {
          // sort the data by createdAt  by mostly created records on top
          response.data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          response.data.map((row) => {
            setRows((prevRows) => [
              ...prevRows,
              createData(
                row.customer.fullName,
                row.courtType,
                row.numberOfCourts,
                row.color,
                row.customer.phone,
                row.customer.email,
                row.size,
                row.customer.zipCode,
                row?.isResurfaced || "NO",
                row.createdAt
              ),
            ]);
          });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <Box display={"flex"} width={"100%"} flexDirection={"column"}>
      <Typography sx={{ p: 4 }} variant="h4">
        Hello Admin , Here are the Requested Quotes
      </Typography>
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          flexDirection={"column"}
          alignItems="center"
          height="50vh"
        >
          <CircularProgress />
          <Typography variant="h5">
            We are getting data ,Please wait and have a cofee
          </Typography>
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell />
                <StyledTableCell>Client Name</StyledTableCell>
                <StyledTableCell align="center">Court Type</StyledTableCell>
                <StyledTableCell align="center">
                  Number of Court
                </StyledTableCell>
                <StyledTableCell align="center">Size of Court</StyledTableCell>
               
                <StyledTableCell align="center">Phone Number</StyledTableCell>
                <StyledTableCell align="center">Email</StyledTableCell>
                <StyledTableCell align="center">ZipCode</StyledTableCell>
                <StyledTableCell align="center">Created At</StyledTableCell>
                <StyledTableCell align="center">
                  Already Resurfaced?
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                 
                  <Row color={row.color} key={row.name} row={row} index={index} />
                 
                
                 
                ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={10}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      )}
    </Box>
  );
}
